<template>
  <div class="home">
    <hua-wei v-if="brand === 'huawei'" :lang="lang"></hua-wei>
    <mei-zu v-else-if="brand === 'meizu'" :lang="lang"></mei-zu>
    <vi-vo v-else-if="brand === 'vivo'" :lang="lang"></vi-vo>
    <xiao-mi v-else-if="brand === 'xiaomi'" :lang="lang"></xiao-mi>
    <other v-else :lang="lang"></other>
  </div>
</template>

<script>
// @ is an alias to /src
import HuaWei from "@/components/huawei";
import MeiZu from "@/components/meizu";
import ViVo from "@/components/vivo";
import XiaoMi from "@/components/xiaomi";
import Other from "@/components/other";
export default {
  name: "Home",
  components: {
    HuaWei,
    MeiZu,
    ViVo,
    XiaoMi,
    Other,
  },
  data() {
    return {
      brand: null,
      lang: null,
    };
  },
  created() {
    let { brand = "", lang = "" } = this.$route.query;

    this.brand = brand.toLowerCase();
    this.lang = lang.toLowerCase();

    if (this.lang == "zh") {
      document.title = "防掉线教程";
    } else {
      document.title = "Anti-drop tutorial";
    }
  },
};
</script>
